<template>
<footer class="">
    <div class="container">
    	<div class="row d-flex justify-content-end">
            <p>
	        <a class="" v-b-modal.ModalLegals centered data-bs-toggle="modal" data-bs-target="#ModalLegals">Emmanuelle Vignon - Diplomée CEAS Paris &#169; 2021</a>
	        </p>
        </div>
    </div>
<!-- ------------------------------- Modal Legals ------------------------------------------------- -->         
<ModalLegals></ModalLegals>
</footer>

</template>

<script>
import ModalLegals from './ModalLegals.vue'
export default { 
	name: 'footer',
    components: {
    ModalLegals
    }
}
</script>

<style scoped>
footer p{
    text-align: left;
    padding-right: 15px;
    font-size: 12px;
}
</style>